import { SET_LIST_PARAMS } from '../actionConstants';

const defaultState = {};
export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_LIST_PARAMS:
      return {
        ...state,
        [action.listKey]: {
          ...state[action.listKey],
          ...action.queryParams,
        },
      };
    case '@@router/LOCATION_CHANGE':
      return {};
    default:
      return state;
  }
};
